import { useEffect, useState } from "react";
import { Cookie, Check, X } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { getConsent, setConsent, applyConsent } from "@/lib/consent";

export const CookieConsent = () => {
  const { t } = useLang();
  const c = t.consent;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const current = getConsent();
    if (current) {
      // Re-apply a previous decision to PostHog on every load.
      applyConsent(current);
    } else {
      setVisible(true);
    }
  }, []);

  const decide = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-5" data-testid="cookie-consent">
      <div className="mx-auto max-w-3xl glass rounded-2xl p-5 sm:p-6 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)]">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <span className="grid place-items-center h-10 w-10 shrink-0 rounded-xl border border-[var(--line-strong)] bg-[rgba(61,123,255,0.08)] text-[var(--blue-bright)]">
              <Cookie size={18} />
            </span>
            <div>
              <h3 className="font-display text-base font-semibold text-white">{c.title}</h3>
              <p className="mt-1 text-sm text-white/90 leading-relaxed">{c.body}</p>
              <p className="mt-1.5 text-xs text-[var(--muted-2)] font-mono">
                {c.necessaryNote}
                {" · "}
                <a href="/privacy" className="underline hover:text-white transition-colors" data-testid="consent-privacy-link">{c.privacy}</a>
              </p>
            </div>
          </div>
          <div className="flex gap-2.5 shrink-0 sm:flex-col lg:flex-row">
            <button
              onClick={() => decide("denied")}
              className="btn-ghost !py-2.5 !px-4 text-sm justify-center"
              data-testid="consent-reject"
            >
              <X size={15} /> {c.reject}
            </button>
            <button
              onClick={() => decide("granted")}
              className="btn-primary !py-2.5 !px-4 text-sm justify-center"
              data-testid="consent-accept"
            >
              <Check size={15} /> {c.accept}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
